import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Box,
} from "@mui/material";
import { useMemo } from "react";
import { formatTime } from "@pages/OrderTracker/components/PlanningAutomation/Timer";
import type { ConsumerInfoOut } from "@providers/hop-ord-server/api";
import IdleTimeIndicator from "./IdleTimeIndicator";
import { tableStyles } from "./utils";

interface ConsumerTableProps {
  backgroundConsumers: ConsumerInfoOut[];
  planGenConsumers: ConsumerInfoOut[];
}

export const ConsumerTable = ({
  backgroundConsumers,
  planGenConsumers,
}: ConsumerTableProps) => {
  const sortedBackgroundConsumers = useMemo(
    () =>
      [...backgroundConsumers].sort((a, b) =>
        (a.consumerName || "").localeCompare(b.consumerName || ""),
      ),
    [backgroundConsumers],
  );

  const sortedPlanGenConsumers = useMemo(
    () =>
      [...planGenConsumers].sort((a, b) =>
        (a.consumerName || "").localeCompare(b.consumerName || ""),
      ),
    [planGenConsumers],
  );

  return (
    <TableContainer component={Paper} variant="outlined">
      <Table size="small" sx={tableStyles}>
        <TableHead>
          <TableRow>
            <TableCell>Consumer Name</TableCell>
            <TableCell align="right">Idle Time</TableCell>
            <TableCell align="center">Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow sx={{ backgroundColor: "grey.100" }}>
            <TableCell colSpan={3} align="center">
              Plan Generation Consumers
            </TableCell>
          </TableRow>
          {sortedPlanGenConsumers.map((consumer, index) => (
            <TableRow key={`${consumer.consumerName || "unknown"}-${index}`}>
              <TableCell>{consumer.consumerName || "Unknown"}</TableCell>
              <TableCell align="right">
                {formatTime(Math.floor(consumer.idleMillis / 1000))}
              </TableCell>
              <TableCell>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <IdleTimeIndicator consumer={consumer} />
                </Box>
              </TableCell>
            </TableRow>
          ))}
          <TableRow sx={{ backgroundColor: "grey.100" }}>
            <TableCell colSpan={3} align="center">
              Background Consumers
            </TableCell>
          </TableRow>
          {sortedBackgroundConsumers.map((consumer, index) => (
            <TableRow key={`${consumer.consumerName || "unknown"}-${index}`}>
              <TableCell>{consumer.consumerName || "Unknown"}</TableCell>
              <TableCell align="right">
                {formatTime(Math.floor(consumer.idleMillis / 1000))}
              </TableCell>
              <TableCell>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <IdleTimeIndicator consumer={consumer} />
                </Box>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
